import { Button } from "@mui/material";
import React from "react";
import { DefaultDialogProps } from "../../../components/default-dialog";
import DefaultDrawer from "../../../components/default-drawer";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import SaveIcon from '@mui/icons-material/Save';
import { useFilasEsperaState } from "../context/filas-espera-context";
import { useFilasEsperaController } from "../context/filas-espera-controller";
import { FilaEsperaForm } from "./fila-espera-form";

export const FilaEsperaDrawer = () => {
    const { showDialog } = useBaseLayoutController();
    const { save, closeForm } = useFilasEsperaController();
    const { dataResponse, showAddEdit } = useFilasEsperaState();

    const getTitle = (): string => {
        if (dataResponse !== undefined && dataResponse !== null && dataResponse?.id !== null)
            return `Editar Registro de Fila de Espera ${dataResponse?.id}`;
        return "Adicionar Registro de Fila de Espera";
    };

    return (
        <DefaultDrawer isOpen={showAddEdit} title={getTitle()} onClose={closeForm}
            actions={() => (
                <Button variant="contained" endIcon={<SaveIcon />} onClick={() => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa informação?",
                        onYesClick: () => {
                            (async () => {
                                await save();
                            })();
                        }
                    } as DefaultDialogProps);
                }}>
                    Salvar
                </Button>
            )}>
            <FilaEsperaForm />
        </DefaultDrawer>
    );
};
